import { SVGProps } from 'react';
import { SvgSymbolIds } from '../constants';
export function IconArrowSquareDown(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} data-sentry-element="svg" data-sentry-component="IconArrowSquareDown" data-sentry-source-file="arrow-square-down.tsx">
            <use href={`#${SvgSymbolIds.ArrowSquareDown}`} data-sentry-element="use" data-sentry-source-file="arrow-square-down.tsx" />
        </svg>;
}